// extracted by mini-css-extract-plugin
module.exports = {"productGrid":"vh-z","centerLink":"wh-z","productSection":"xh-z","item":"yh-z","ctaButton":"zh-z"};